<template>
  <div class="login">
    <div class="loginBox">
      <div class="title">
        <strong>{{$t('password.title')}}</strong>
      </div>
      <div class="inputBox">
        <img src="../assets/images/user.png" alt="s" class="limg" />
        <input type="text" v-model="form.userName" :placeholder="$t('password.zhanghao')" />
      </div>
      <div class="inputBox">
        <img src="../assets/images/user.png" alt="s" class="limg" />
        <input type="text" v-model="form.mobile" :placeholder="$t('password.shouji')" />
      </div>
      <div class="inputBox">
        <img src="../assets/images/user.png" alt="s" class="limg" />
        <input type="text" v-model="form.verCode" :placeholder="$t('password.yanzhenma')" />
        <div class="butCode" v-if="tm<=0" @click="getCode()">{{$t('password.duanxin')}}</div>
        <div class="butCode" v-else>{{$t('password.duanxin')+`(${tm})`}}</div>
      </div>
      <div class="inputBox">
        <img src="../assets/images/user.png" alt="s" class="limg" />
        <input type="password" v-model="form.userPwd" :placeholder="$t('password.mima')" />
      </div>
      <div class="inputBox">
        <img src="../assets/images/user.png" alt="s" class="limg" />
        <input type="password" v-model="form.twoPwd" :placeholder="$t('password.qieren')" />
      </div>
      <div class="but" @click="retrievePwd()">{{$t('password.sub')}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        mobile: "",
        userName: "",
        userPwd: "",
        twoPwd:'',
        verCode: "",
      },
      tm:-1
    };
  },
  methods: {
    // 前往登录
    goLogin() {
      this.$router.push("/login");
    },
    async retrievePwd(){
        if(this.form.userPwd!=this.form.twoPwd){
            this.$message.error('两次输入密码不一致')
            return
        }
        let {data:res} = await this.$http.post('/c/retrievePwd',this.form)
        if(res.code!=200){
            
            return this.$message.error(res.message)
        }
        this.$message.success('修改成功，跳转登录')
        this.goLogin()
    },
    getCode(){
      if(!this.form.mobile){
        return this.$message.error('请输入手机号')
      }
      this.tm = 60;
      let tmil = setInterval(() => {
        this.tm--;
        if (this.tm < 0) {
          clearInterval(tmil);
        }
      }, 1000);

      this.$http.post(`/c/sms/retrievePwd/${this.form.mobile}`)
    }

  },
};
</script>


<style lang="less" scoped>
.login {
  height: 50rem;
  background-color: #f1f1f1;
  padding-top: 10rem;
  background-image: url("../assets/images/logBg.jpg");
  background-repeat: no-repeat;
  .loginBox {
    width: 27.5rem;
    height: 33.125rem;
    background-color: #fff;
    margin: 0 auto 0;
    border-radius: .9375rem;
    padding: 1.875rem;
    box-sizing: border-box;
    .title {
      text-align: center;
      font-size: 1.375rem;
      margin-bottom: .625rem;
    }
    .inputBox {
      border-bottom: .0313rem solid #ccc;
      height: 4.0625rem;
      .limg {
        width: 1.25rem;
        height: 1.25rem;
        margin-right: .625rem;
      }
      input {
        width: calc(100% - 12.5rem);
        line-height: 4.0625rem;
        outline: none;
        border: none;
      }
      .butCode {
        display: inline-block;
        float: right;
        margin-top: .625rem;
        width: 8.125rem;
        padding: .625rem;
        text-align: center;
        background-color: #f1f1f1;
        color: #ccc;
        border: .0313rem solid #ccc;
      }
    }
    .but {
      height: 3.125rem;
      background-color: rgb(67, 188, 183);
      text-align: center;
      line-height: 3.125rem;
      color: #fff;
      margin-top: 1.875rem;
      border-radius: .3125rem;
    }
    .ft {
      margin-top: 1.875rem;
      .lan {
        color: rgb(67, 188, 183);
        text-align: center;
      }
      .fr {
        color: rgb(148, 13, 13);
      }
    }
  }
}
</style>